import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'miliDateTime'
})
export class MiliDateTimePipe implements PipeTransform {

  transform(value: number) {
    let date = new Date(value);
    return date.toDateString() + " " + date.toTimeString();
  }

}
